angular.module('app.controllers').controller 'HomeCtrl', [
  '$scope', 'APIPrograms', 'APIRead2', '$rootScope'
].append (self, APIPrograms, APIRead2, root) ->

  self.days = ['01', '02.10.2024', '03.10.2024', '04.10.2024', '05.10.2024']
  self.day = parseInt(self.get('day')) || null
  mday = moment().format('DD.MM.YYYY')
  if !self.day? || self.day not in [1..4]
    self.day = if mday in self.days then self.days.indexOf(mday) else 1

 
  APIRead2.query {entry_type: 'program_highlights', da: self.day, limit: 120}, (data) ->
    self.programs = data
  